module.exports = __webpack_public_path__ + "header-profile-skin-1.png?85efa900c0fc12fee15a5398deba06e8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/inspinia/patterns/header-profile-skin-1.png
// module id = 165
// module chunks = 0